/*
  Pfeile links und rechts auf dem Hauptbild der Produktgalerie.

  Warum eigens gebaut: Das Theme zeigt auf dem Desktop nur die Miniaturen
  zum Wechseln. Die Pfeile des Themes gehoeren zum Wischen auf dem Handy
  und sind ab Tablet ausgeblendet.

  Die Pfeile klicken schlicht die vorige oder naechste Miniatur an. So
  bleibt die Bildumschaltung des Themes zustaendig - Zoom, Video und
  Varianten-Bildwechsel arbeiten unveraendert weiter.
*/
(function () {
  function aufbauen(wrapper) {
    if (wrapper.dataset.hssPfeile === '1') return;
    var thumbs = wrapper.querySelectorAll('.thumbnail-list__item .thumbnail');
    if (thumbs.length < 2) return;
    wrapper.dataset.hssPfeile = '1';

    var bereich = wrapper.querySelector('.product__media-list');
    if (!bereich || !bereich.parentElement) return;

    function machen(richtung, beschriftung) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hss-galerie__pfeil hss-galerie__pfeil--' + (richtung < 0 ? 'zurueck' : 'vor');
      b.setAttribute('aria-label', beschriftung);
      b.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="' +
        (richtung < 0 ? 'm15 18-6-6 6-6' : 'm9 6 6 6-6 6') +
        '"/></svg>';
      b.addEventListener('click', function () {
        var alle = wrapper.querySelectorAll('.thumbnail-list__item .thumbnail');
        var aktiv = 0;
        alle.forEach(function (t, i) {
          if (t.getAttribute('aria-current') === 'true') aktiv = i;
        });
        var ziel = (aktiv + richtung + alle.length) % alle.length;
        alle[ziel].click();
      });
      return b;
    }

    var huelle = document.createElement('div');
    huelle.className = 'hss-galerie__pfeile';
    huelle.appendChild(machen(-1, 'Vorheriges Bild'));
    huelle.appendChild(machen(1, 'Nächstes Bild'));
    bereich.parentElement.appendChild(huelle);
  }

  function start() {
    document.querySelectorAll('.product__media-wrapper').forEach(aufbauen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
